@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
}

.content {
    grid-column: content;
    display: grid;
    grid-template-columns: subgrid;
    padding-top: var(--spacer-80);
    padding-bottom: var(--spacer-64);
    row-gap: var(--spacer-24);
    text-align: center;
}

.headline {
    composes: fontHB144 from "../../styles/typography.module.scss";
    font-family: "PP Right Grotesk", sans-serif;
    grid-column: 1 / -1;
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
    grid-column: col-start 4 / span 6;

    @media ($below-tablet) {
        grid-column: col-start 2 / span 10;
    }

    @media ($below-mobile) {
        grid-column: content;
    }
}

.ctaWrapper {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;

    @media ($below-tablet) {
        margin-bottom: var(--spacer-24);
    }

    @media ($below-mobile) {
        margin-bottom: 0;
    }
}

.imageWrapper {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;

    :global(.imageDataWrapper) {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        width: 100%;
    }

    img,
    svg {
        display: block;
        max-width: 100%;
        max-height: 240px;
        width: auto;
        height: auto;
        object-fit: contain;
    }

    svg {
        color: var(--color-contrast);
    }
}
